Alpine.data('SevenCtaButton', (el) => ({
    init() {
        this.createMobileCta();
    },

    createMobileCta() {
        if (document.querySelector('#mobile-cta') !== null) {
            return;
        }

        let mobileCtaWrapper = document.createElement('div');
        mobileCtaWrapper.id = 'mobile-cta';

        let mobileCtaButton = el.cloneNode(true);
        mobileCtaWrapper.appendChild(mobileCtaButton)

        document.querySelector('body').appendChild(mobileCtaWrapper);
    }
}));